import index from "../index/en.js"
import login from "../login/es.js"
import projectList from "../projectList/es.js"
import post from "../post/es.js"
import admin from "../admin/es.js"

export default {
  index,
  login,
  projectList,
  post,
  admin
}



// WEBPACK FOOTER //
// ./src/locale/lang/es.js